var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { Component } from 'react';
import { Submenu } from './Submenu';
import classNames from 'classnames';
import { defaultProps } from './defaults';
import { ButtonTag, DivTag, UlTag, addComponentPrefix } from '../../Utils/AtomicTag';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@feb-team/legao-icons-react';
export var treeFindPath = function (tree, func, path) {
    var e_1, _a;
    if (!tree)
        return [];
    try {
        for (var tree_1 = __values(tree), tree_1_1 = tree_1.next(); !tree_1_1.done; tree_1_1 = tree_1.next()) {
            var data = tree_1_1.value;
            if (!(data && data.key)) {
                continue;
            }
            path.push(data.key);
            if (func(data))
                return path;
            if (data.children) {
                var findChildren = treeFindPath(data.children, func, path);
                if (findChildren.length)
                    return findChildren;
            }
            path.pop();
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tree_1_1 && !tree_1_1.done && (_a = tree_1.return)) _a.call(tree_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return [];
};
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.getShowObj = function (keys) {
            if (!keys) {
                return;
            }
            var showObj = {};
            keys.forEach(function (key) {
                showObj[key] = true;
            });
            return showObj;
        };
        _this.clickMenu = function (hasChildren, key, onShow, hoverType, n) {
            var _a, _b;
            var _c = _this.props, data = _c.data, onChangeOpen = _c.onChangeOpen, onChangeSelect = _c.onChangeSelect, onClickMenu = _c.onClickMenu, isHorizontal = _c.isHorizontal;
            var showMini = _this.state.showMini;
            var res = treeFindPath(data, function (data) { return data.key === key; }, []);
            var openKeys = res;
            var keyLength = key.split('-').length;
            if (hasChildren && _this.state.openKeys.indexOf(key) > -1 && !showMini && !isHorizontal) {
                var showObj = __assign(__assign({}, _this.state.showObj), (_a = {}, _a[key] = onShow, _a));
                _this.setState({
                    showObj: showObj,
                });
            }
            else {
                var setOpenKeys = showMini || isHorizontal
                    ? openKeys
                    : Array.from(new Set(__spread(openKeys, _this.state.openKeys)));
                var openKeysObj = _this.getShowObj(setOpenKeys);
                var showTempObj = __assign({}, openKeysObj);
                // const showObj = showMini || isHorizontal ? showTempObj : { ...showTempObj, [key]: onShow }
                var showObj = showMini || isHorizontal ? showTempObj : __assign(__assign({}, _this.state.showObj), (_b = {}, _b[key] = onShow, _b));
                if (hasChildren || hoverType) {
                    if (keyLength < 3) {
                        if (hoverType) {
                            _this.setState({
                                onShow: hoverType,
                            });
                        }
                        _this.setState({ openKeys: setOpenKeys, showObj: showObj });
                    }
                    else {
                        console.warn('已经超过3级导航');
                    }
                }
                else {
                    _this.setState({ selectedKey: key, openKeys: setOpenKeys, showObj: showObj });
                    onChangeSelect(key);
                }
                if (n == '1') {
                    onClickMenu(key, openKeys);
                }
            }
        };
        _this.mouseMenu = function (onShow) {
            _this.setState({
                onShow: onShow,
            });
        };
        _this.mouseLeave = function () {
            _this.setState({
                onShow: false,
            });
        };
        _this.toggleNav = function () {
            _this.setState({
                showMini: !_this.state.showMini,
            });
        };
        var defaultSelectedKey = props.defaultSelectedKey, defaultOpenKeys = props.defaultOpenKeys;
        _this.state = {
            selectedKey: defaultSelectedKey,
            openKeys: defaultOpenKeys,
            showMini: false,
            onShow: false,
            showObj: _this.getShowObj(defaultOpenKeys),
        };
        return _this;
    }
    Menu.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, theme = _c.theme, hasIcon = _c.hasIcon, logo = _c.logo, data = _c.data, userInfo = _c.userInfo, navItem = _c.navItem, hasMini = _c.hasMini, defaultOpenKeys = _c.defaultOpenKeys, defaultSelectedKey = _c.defaultSelectedKey, isHorizontal = _c.isHorizontal, style = _c.style, children = _c.children, color = _c.bgColor, className = _c.className, rest = __rest(_c, ["theme", "hasIcon", "logo", "data", "userInfo", "navItem", "hasMini", "defaultOpenKeys", "defaultSelectedKey", "isHorizontal", "style", "children", "bgColor", "className"]);
        var _d = this.state, showMini = _d.showMini, selectedKey = _d.selectedKey, openKeys = _d.openKeys;
        // const bgColor = theme === `light` ? `bg-white` : `bg-black`
        var textColor = theme === "light" ? "text-brand-600" : "text-white";
        var miniCls = showMini ? "w-px-64" : "w-px-240";
        var onToggle = showMini ? React.createElement(ArrowRightOutlined, null) : React.createElement(ArrowLeftOutlined, null);
        var globalCls = !isHorizontal
            ? ['shadow-xs']
            : ['shadow-xs', 'h-px-64', 'w-full', 'leading-16'];
        var atomicsBtCls = [
            'border-0',
            'm-0',
            'py-px-10',
            textColor,
            miniCls,
            'block',
        ];
        var atomicsUlCls = [!isHorizontal ? 'py-px-8' : 'float-left'];
        var atomicsDivCls = globalCls.concat([miniCls]);
        var atomicsLogoDivCls = !isHorizontal
            ? ['py-5', showMini ? 'px-2' : 'px-12', 'text-center']
            : ['px-px-12', 'py-4', 'float-left', 'text-center'];
        return (React.createElement(DivTag, __assign({ name: Menu.NAME, atomics: atomicsDivCls, className: classNames(addComponentPrefix("menu-" + theme) + " " + className, (_a = {},
                _a[addComponentPrefix('has-mini')] = showMini,
                _a[addComponentPrefix('bg-black-1')] = theme === "dark",
                _a[addComponentPrefix('has-horizontal')] = isHorizontal,
                _a)), style: style, onMouseLeave: this.state.showMini || isHorizontal ? this.mouseLeave : undefined }, rest),
            children,
            logo && (React.createElement(DivTag, { atomics: atomicsLogoDivCls, className: classNames((_b = {},
                    _b[addComponentPrefix('logo')] = !isHorizontal,
                    _b)) }, logo)),
            data && (React.createElement(UlTag, { atomics: atomicsUlCls }, data &&
                data.length > 0 &&
                data.map(function (menu) {
                    return (React.createElement(Submenu, { level: 1, title: menu.title, icon: menu.icon, menuKey: menu.key, key: menu.key, bgColor: theme === "light" ? "bg-white" : "bg-black", color: textColor, hasIcon: hasIcon, selectedKey: selectedKey, openKeys: openKeys, children: menu.children, clickMenu: _this.clickMenu, href: menu.href, target: menu.target, navItem: navItem, showMini: _this.state.showMini, isHorizontal: isHorizontal, hasMini: hasMini, menuData: menu, mouseMenu: _this.mouseMenu, onMouse: _this.state.showMini || isHorizontal, onShow: _this.state.onShow, showObj: _this.state.showObj }));
                }))),
            userInfo ? React.createElement(React.Fragment, null, userInfo) : null,
            hasMini && !isHorizontal ? (React.createElement(ButtonTag, { title: "\u5C55\u5F00\u6536\u8D77", atomics: atomicsBtCls, onClick: this.toggleNav }, onToggle)) : null));
    };
    Menu.NAME = 'menu';
    Menu.displayName = 'Menu';
    Menu.defaultProps = defaultProps;
    return Menu;
}(Component));
export { Menu };
